<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:08:35
 * @LastEditTime: 2019-10-22 17:17:37
 * @LastEditors: Please set LastEditors
 -->
<template>
<div class="mainBox">
  <!-- <header class="header">
            &lt;!&ndash;<div class="el-icon-refresh icon"></div>
            <div class="el-icon-refresh icon"></div>
            <el-menu
                    :default-active="headActive"
                    class="el-menu-demo"
                    mode="horizontal"
                    active-text-color="#fff"
                    background-color="#3a3d47"
                    text-color="#fff"
                    @select='hadleselect'
                    :router="true"
                    :unique-opened="true"
            >
                <el-submenu v-if="value.children" v-for="(value,index) in headList" :key="index">
                    <template slot="title">{{value.name}}</template>
                    <el-menu-item
                            :index="val.path"
                            v-for="(val,key) in value.children"
                            :key="key"
                    >{{val.name}}
                    </el-menu-item>
                </el-submenu>
                <el-menu-item :index="value.path" v-else>
                    <template slot="title">{{value.name}}</template>
                </el-menu-item>
            </el-menu>&ndash;&gt;
        </header> -->
<!-- <div class="leftMenu">
    <el-menu default-active="2" class="el-menu-vertical-demo" :background-color="bgc" text-color="#fff" active-text-color="#008b7d" :unique-opened="true" :router="true">
      <el-submenu v-for="(items,index) in menu" :index="index+''" :key="index">
        <template slot="title">
          <i :class="items.class" style="font-weight: 400;color: #fff"></i>
          <span style="margin-left: 10px">{{items.name}}</span>
        </template>
        <el-menu-item-group v-for="(item,itemIndex) in items.children" :key="itemIndex">
          <el-menu-item :index="item.path">{{item.name}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div> -->
  <div class="mainContent">
    <router-view>
    </router-view>
  </div>
</div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      bgc: "#202229",
      activeIndex: -1,
      headActive: "",
      headList: [],
      menu: [
        /*智能物流*/
        {
          "name": "概况",
          "path": "",
          "class": "fa fa-bar-chart",
          "children": [{
            "name": "概况",
            "path": "/survey",
            "children": []
          }]
        },
        {
          "name": "物流管理",
          "path": "",
          "class": "fa fa-truck",
          "children": [{
              "name": "入库管理",
              "path": "/instockManage",
              "children": []
            },
            {
              "name": "发货管理",
              "path": "/deliverManage",
              "children": []
            },
            {
              "name": "退货管理",
              "path": "/refundManage",
              "children": []
            },
            {
              "name": "调仓管理",
              "path": "/ware",
              "children": []
            },
            {
              "name": "商品调拨",
              "path": "/requisitionManage",
              "children": []
            },
            {
              "name": "零售管理",
              "path": "/retailManage",
              "children": []
            },
            {
              "name": "追踪查询",
              "path": "/traceManage",
              "children": []
            }
          ]
        },
        {
          "name": "在线订单管理",
          "path": "",
          "class": "fa fa-file-text-o",
          "children": [{
              "name": "商品上架管理",
              "path": "/goodsOnput",
              "children": []
            },
            {
              "name": "经销商订单管理",
              "path": "/dealerOrder",
              "children": []
            },
            {
              "name": "门店订单管理",
              "path": "/storeOrder",
              "children": []
            }
          ]
        },
        {
          "name": "返利管理",
          "path": "back",
          "class": "fa fa-file-text-o",
          "children": [{
              "name": "返利发放记录",
              "path": "/rebateIssue",
              "children": []
            },
            {
              "name": "经销商返利管理",
              "path": "/rebateManage",
              "children": []
            },
            {
              "name": "经销商余额明细",
              "path": "/touchBalance",
              "children": []
            },
          ]
        },

        {
          "name": "报表管理",
          "path": "",
          "class": "fa fa-file-text-o",
          "children": [{
              "name": "总部库存统计",
              "path": "/baseCount",
              "children": []
            },
            {
              "name": "经销商窜货统计",
              "path": "/fleeingCount",
              "children": []
            },
            {
              "name": "经销商库存统计",
              "path": "/Dealerstock",
              "children": []
            },
            // {
            //   "name": "礼品库存统计",
            //   "path": "/giftCount",
            //   "children": []
            // },
            {
              "name": "门店库存统计",
              "path": "/storeCount",
              "children": []
            },
            {
              "name": "盘点统计",
              "path": "/inventoryCount",
              "children": []
            },
            {
              "name": "产品周转率统计",
              "path": "/turnCount",
              "children": []
            }
          ]
        },
        {
          "name": "基础管理",
          "path": "",
          "class": "fa  fa-cog",
          "children": [{
              "name": "基础设置",
              "path": "/basicSetting",
              "children": []
            },
            {
              "name": "仓库设置",
              "path": "/instockSetting",
              "children": []
            }
          ]
        },

      ],
      menuHead: [{
        name: "系统",
        path: "",
        children: []
      }]
    }
  },
  created() {},
  mounted() {
    //this.getUrl();
  },
  methods: {
    changeStyle(index) {
      this.activeIndex = index;
    },
    /*// 获取头部 导航信息
    getUrl() {
        this.$get('basic',"/head",{}).then(res => {
            //console.log(res);
            this.headList = res;
            this.getSlide(this.headList[0].Ajaxpath)
            this.headActive = this.headList[0].path
            //console.log(this.headActive)
        });
    },
    //获取侧边导航
    getSlide(route) {
        this.$get('basic',route,{}).then(res => {
            this.menu = res;
        })
    },*/
    // 菜单激活回调
    /*  hadleselect(value, index) {
          //console.log(value, index);
          this.getSlide(value);
          this.activeIndex = 0;
          this.headActive = value;
      }*/
  },
  components: {}
};
</script>

<style lang="less" scoped>
.mainBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .header {
    position: fixed;
    left: 240px;
    top: 0;
    right: 0;
    background-color: #3a3d47;
    height: 60px;
    z-index: 99;
    display: flex;
    align-items: center;

    .icon {
      color: #fff;
      font-size: 20px;
      width: 80px;
      text-align: center;
    }
  }

  .leftMenu {
    padding-top: 60px;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    background-color: #202229;
    width: 240px;
    height: 100%;
    overflow: hidden;
  }

  .mainContent {
    height: 100%;
    overflow: scroll;
    top: 0;
    left: 0;
    right: 0;
    bottom: 10px;
    // position: absolute;
    // left: 250px;
    // top: 60px;
    // bottom: 0;
    // right: 0px;
  }
}

// /deep/ .el-submenu__icon-arrow{
//     display: none;
// }
</style>
